var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1533_221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1533_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 53.3662C60.4345 53.3662 77 47.382 77 40C77 32.618 60.4345 26.6338 40 26.6338C19.5655 26.6338 3 32.618 3 40C3 47.382 19.5655 53.3662 40 53.3662Z",
    stroke: "#61DAFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.765 46.6832C37.9822 63.4267 51.7426 74.0078 58.4996 70.3168C65.2565 66.6259 62.4514 50.0605 52.2341 33.317C42.0169 16.5735 28.2565 5.99237 21.4996 9.68335C14.7426 13.3743 17.5477 29.9397 27.765 46.6832Z",
    stroke: "#61DAFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.765 33.3167C17.5477 50.0602 14.7426 66.6256 21.4996 70.3166C28.2565 74.0076 42.0169 63.4264 52.2341 46.683C62.4514 29.9395 65.2565 13.3741 58.4996 9.6831C51.7426 5.99212 37.9822 16.5733 27.765 33.3167Z",
    stroke: "#61DAFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9993 46.5238C43.8076 46.5238 46.8948 43.6029 46.8948 39.9998C46.8948 36.3967 43.8076 33.4758 39.9993 33.4758C36.1911 33.4758 33.1039 36.3967 33.1039 39.9998C33.1039 43.6029 36.1911 46.5238 39.9993 46.5238Z",
    fill: "#61DAFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/React.edd0c3b47a6b6504a959b8629c1daf2b.svg";
export { ForwardRef as ReactComponent };